function isStaffAuthChallenge(url) {
  const path = String(url || '')
  return path.indexOf('/auth/login') !== -1 || path.indexOf('/auth/mfa/') !== -1
}

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const {
        auth: { _authToken, 
           _accessTokenPrivilege
         }
      } = store.getState();
      const accessTokenPrivilegeToken = localStorage.getItem('accessTokenPrivilege')
      const Token = localStorage.getItem('Token')
       var check_privilage = config.url.search("privilege-api");
       var krungthai = config.url.search("krungthai-axa");
       console.log(krungthai)
       localStorage.setItem('krungthai', krungthai)
       if (config.url.indexOf('/auth/mfa/') !== -1) {
        return config;
       }
       if (check_privilage > 0 && krungthai < 1) {
       config.headers.Authorization = `Bearer ${accessTokenPrivilegeToken}`;
       } else {
      config.headers.Authorization = `Bearer ${Token}`;
       }
      return config;
    },
    err => Promise.reject(err)
  );
  axios.interceptors.response.use(
    res => res,
    err => {
      const status = err.response && err.response.status
      const url = err.config && err.config.url
      if (status === 401 && !isStaffAuthChallenge(url)) {
        window.location.assign('/logout')
      }
      return Promise.reject(err)
    }
  );
}
